import { __read } from "tslib";
import { useIdentity } from '@office-start/identity-service';
import * as React from 'react';
export var NovaDataProvider = function (_a) {
    var children = _a.children;
    var identity = useIdentity().data;
    var isMsa = identity === null || identity === void 0 ? void 0 : identity.isMsa;
    var _b = __read(React.useState(), 2), NovaDataProviderRenderer = _b[0], setNovaDataProviderRenderer = _b[1];
    React.useEffect(function () {
        // Check if isMsa has been resolved.
        if (isMsa !== undefined) {
            setNovaDataProviderRenderer(React.lazy(function () {
                return isMsa
                    ? import('./NovaConsumerDataProvider')
                    : import('./NovaEnterpriseDataProvider');
            }));
        }
    }, [isMsa]);
    return (React.createElement(React.Suspense, { fallback: "" }, NovaDataProviderRenderer && (React.createElement(NovaDataProviderRenderer, null, children))));
};
//# sourceMappingURL=NovaDataProvider.js.map